import styled from 'styled-components';
import TextSubHeading from "../../../../textComponents/TextSubHeading";
import TextCallout2 from "../../../../textComponents/TextCallout2";
import { IconRight } from "../../../../Icon";
import { colors } from "../../../../../styleguide";
export var TextSubHeadingStyled = styled(TextSubHeading).withConfig({
  displayName: "CategoryLinkstyles__TextSubHeadingStyled",
  componentId: "sc-1lmlf3n-0"
})(["font-size:15px;&:hover{text-decoration:underline;}"]);
export var StyledIconRight = styled(IconRight).withConfig({
  displayName: "CategoryLinkstyles__StyledIconRight",
  componentId: "sc-1lmlf3n-1"
})(["width:8px;height:8px;padding-left:4px;"]);
export var TextCallout2Hover = styled(TextCallout2).withConfig({
  displayName: "CategoryLinkstyles__TextCallout2Hover",
  componentId: "sc-1lmlf3n-2"
})(["line-height:28px;color:", ";&:hover{text-decoration:underline;}"], colors.grey700);
//# sourceMappingURL=CategoryLink.styles.js.map